var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 6.333a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v4.334a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6.333Z",
  stroke: "#fff",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 6h12",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.333 1.333v2M10.667 1.333v2",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 10,
  r: 0.667,
  fill: "#fff"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.667,
  cy: 10,
  r: 0.667,
  fill: "#fff"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.333,
  cy: 10,
  r: 0.667,
  fill: "#fff"
})));
export default SvgCalendar;